(() => {
  if (customElements.get('featured-blog-slider')) {
    return;
  }

  class FeaturedBlogSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {
        perPage: 1,
        gap: '2.4rem',
        padding: 40,
        arrows: false,
        pagination: false
      };
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('.js-slider')) return;

      this.slider = new Splide(
        this.querySelector('.js-slider'),
        this.options
      ).mount();
    }
  }

  customElements.define('featured-blog-slider', FeaturedBlogSlider);
})();
